import { RootState } from '../../../config/redux/store';
import { IBreadCrumbSlice } from './type';

export const selectBreadCrumbState = (state: RootState): IBreadCrumbSlice =>
	state.breadCrumb;
